<template>
    <div class="red darken-5 row wrap text-center justify-center">
        <v-layout row align-top justify-center class="pb-12">
            <v-flex
                md2
                sm6
                xs12
                style="border-left: 1px solid #0D3C83;min-width: 300px;"
                class="text-center white--text"
                justify-center
                text-center
                pa-6
            >
                <h2 class="h3 text -left pt-6 pb-6 ">
                    Akademicki Związek <br />Sportowy
                </h2>
                <v-img
                    :aspect-ratio="16 / 9"
                    max-height="285px"
                    :src="'/images/' + '1aAZS-428x285.jpg'"
                    alt="Zdjęcie poglądowe Akademicki Związek Sportowy"
                >
                </v-img>
                <div class="txt text-left white--text pa-2">
                    Akademicki Związek Sportowy to organizacja, dzięki której
                    możesz być aktywny, uprawiać sport, odnaleźć swoje pasje i
                    zainteresowania, a dodatkowo reprezentować Uczelnię podczas
                    zawodów sportowych o randze regionalnej, krajowej
                    i&nbsp;międzynarodowej.
                </div>
                <div class="red darken-5 text-right">
                    <v-btn
                        :href="'/akademicki-zwiazek-sportowy'"
                        outlined
                        class="ma-2"
                        color="white"
                        aria-label="Akademicki Związek Sportowy - zobacz więcej"
                    >
                        Zobacz więcej
                    </v-btn>
                </div>
            </v-flex>

            <v-flex
                style="border-left: 1px solid #0D3C83;min-width: 300px;"
                md2
                sm6
                xs12
                class="text-center white--text"
                justify-center
                text-center
                pa-6
            >
                <h2 class="h3 text-center pt-6 pb-6">
                    Samorząd Studencki i Studenckie Koła Naukowe
                </h2>
                <v-img
                    :aspect-ratio="16 / 9"
                    max-height="285px"
                    :src="'/images/' + '2dzialalnosc-studencka-428x285.jpg'"
                    alt="Na zdjęciu studenci Państwowej Uczelni Angelusa Silesiusa"
                >
                </v-img>
                <div class="txt text-left white--text pa-2">
                    Organizacje studenckie i studenckie koła naukowe stwarzają
                    nie tylko możliwość rozwoju naukowego, udziału w
                    konferencjach, dyskursach, seminariach, warsztatach i
                    publikowania wyników swoich prac badawczych, ale również do
                    spotkań z pasjonatami nauki.
                </div>
                <div class="red darken-5 text-right">
                    <v-btn
                        :href="'/dzialalnosc-studencka'"
                        outlined
                        class="ma-2"
                        color="white"
                        aria-label="Studenckie Koła Naukowe - zobacz więcej"
                    >
                        Zobacz więcej
                    </v-btn>
                </div>
            </v-flex>

            <v-flex
                style="border-left: 1px solid #0D3C83;min-width: 300px;"
                md2
                sm6
                xs12
                class="text-center white--text"
                justify-center
                text-center
                pa-6
            >
                <h2 class="h3 text-center pt-6 pb-6 ">
                    Wydawnictwo Uczelniane
                </h2>
                <v-img
                    :aspect-ratio="16 / 9"
                    max-height="285px"
                    :src="'/images/' + '4bwydawnictwo-uczelniane-428x285.jpg'"
                    alt="Na zdjęciu studenci Państwowej Uczelni Angelusa Silesiusa"
                >
                </v-img>
                <div class="txt text-left white--text pa-2">
                    Wydawnictwo Akademii Nauk Stosowanych Angelusa Silesiusa
                    znajduje się na ministerialnej liście wydawnictw
                    punktowanych (80 pkt.) i ma na swoim koncie liczne
                    monografie, w tym w językach obcych oraz cykliczne prace pod
                    redakcją, skrypty i regionalia.
                </div>
                <div class="red darken-5 text-right">
                    <v-btn
                        :href="'/wydawnictwo-uczelniane'"
                        outlined
                        class="ma-2"
                        color="white"
                        aria-label="Wydawnictwo Uczelniane - zobacz więcej"
                    >
                        Zobacz więcej
                    </v-btn>
                </div>
            </v-flex>

            <v-flex
                style="border-left: 1px solid #0D3C83;border-right: 1px solid #0D3C83;min-width: 300px;"
                md2
                sm6
                xs12
                class="text-center white--text"
                justify-center
                text-center
                pa-6
            >
                <h2 class="h3 text-center pt-6 pb-6 ">
                    Wałbrzyski Uniwersytet Trzeciego Wieku
                </h2>
                <v-img
                    :aspect-ratio="16 / 9"
                    max-height="285px"
                    :src="'/images/' + 'senior428x265.jpg'"
                    alt="Na zdjęciu Seniorzy uczestniczący w zajęciach Uniwersytetu Trzeciego Wieku"
                >
                </v-img>
                <div class="txt text-left white--text pa-2">
                    Wałbrzyski Uniwersytet Trzeciego Wieku to doskonałe miejsce
                    dla seniorów, którzy chcą pogłębić swoją wiedzę, rozwinąć
                    zainteresowania, odkryć nowe pasje, spędzić aktywnie czas, a
                    nade wszystko nawiązać długoletnie przyjaźnie.
                </div>
                <div class="red darken-5 text-right">
                    <v-btn
                        :href="'/walbrzyski-uniwersytet-trzeciego-wieku'"
                        outlined
                        class="ma-2"
                        color="white"
                        aria-label="Wałbrzyski Uniwersytet Trzeciego Wieku - zobacz więcej"
                    >
                        Zobacz więcej
                    </v-btn>
                </div>
            </v-flex>

            <v-flex md12 xs12>
                <v-row class="justify-center" row wrap>
                    <div class="square45"></div>
                </v-row>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
export default {
    data: () => ({})
};
</script>

<style scoped>
.h3 {
    border: 0px solid yellow;
    min-height: 173px;
}

.txt {
    min-height: 260px;
}

.square45 {
    text-align: center;
    position: absolute;
    z-index: 1;
    margin: 23px;
    background: #c20444;
    display: block;
    height: 50px;
    width: 50px;
    transform: rotate(45deg);
}

/* mouse over link */
a:hover {
    background-color: #0e3d85;
    color: white;
}
</style>
